/**
 * @fileoverview The i18next namespace the public-tools bundles register under.
 * @package @puffin-core/public-tools
 *
 * A ZERO-IMPORT leaf module, deliberately: `usePublicToolsTranslate()` is imported by every
 * component in this package, and routing the constant through `strings/index.js` would drag `en.js`
 * and `es.js` into every one of those import chains for one short string.
 *
 * LINKABLE-ASSETS-001 C1 (2026-10-13) — born on the namespace mechanism (`publicTools`, #40 — the
 * coordinator's stamp; registered in `@puffin-core/i18n-namespaces`).
 *
 * @module @puffin-core/public-tools/strings/namespace
 */

/** The canonical namespace under which public-tools strings live in i18next. */
export const PUBLIC_TOOLS_NAMESPACE = 'publicTools';
